import { useEffect, useState } from 'react';
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout';
import PublicLayout from '@/layouts/PublicLayout';
import { apiService, KIOSK_AUTH_TOKEN_CHANGED_EVENT } from '@/services/apiService';

function useKioskAuthed() {
  const [authed, setAuthed] = useState(() => apiService.isAuthenticated());

  useEffect(() => {
    const sync = () => setAuthed(apiService.isAuthenticated());
    window.addEventListener(KIOSK_AUTH_TOKEN_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(KIOSK_AUTH_TOKEN_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return authed;
}

/**
 * Shell for unknown URLs: guests keep the public header, a signed-in session keeps the account
 * header. Both are the app's own layouts, so the page gets the usual background and bottom nav.
 */
const NotFoundLayout = () => {
  const authed = useKioskAuthed();
  return authed ? <AuthenticatedLayout /> : <PublicLayout />;
};

export default NotFoundLayout;
